import {
  CardTypes,
  CorporateInvoiceDto,
  CreditCardsDto,
  CreditCardsDtoTransformer,
  PaymentMethod,
  PaymentType,
  UserWalletConfigDto,
  UserWalletConfigModel
} from '../models/payments';

function getCardType(cardName: string) {
  switch (cardName.toUpperCase()) {
    case 'VISA':
      return CardTypes.VISA;
    case 'MASTERCARD':
      return CardTypes.MASTERCARD;
  }
}

export const creditCardDtoToPaymentMethod = ({ cards }: CreditCardsDto): PaymentMethod[] => {
  if (!cards) {
    return [];
  }
  return cards.map(item => {
    const paymentMethod: PaymentMethod = {
      paymentType: PaymentType.CREDIT_CARD,
      id: item.id,
      display: `**** ${item.last_4}`,
      cardType: getCardType(item.type),
      //TODO: refactor when v2 rolled out
      expiryDate: item.expire_month ? `${item.expire_month}/${item.expire_year}` : undefined
    };
    return paymentMethod;
  });
};

export function corporateInvoiceDtoToPaymentMethod(invoice: CorporateInvoiceDto): PaymentMethod {
  return {
    paymentType: PaymentType.CORPORATE_INVOICE,
    id: invoice.id,
    display: invoice.name,
    isEnabled: invoice.is_enabled
  };
}

export function corporateInvoicesDtoToPaymentMethods(invoices?: CorporateInvoiceDto[]): PaymentMethod[] {
  if (!invoices) {
    return [];
  }
  return invoices.map(corporateInvoiceDtoToPaymentMethod);
}

export function creditCardDtoToPaymentMethodTransformer({
  cards,
  corporate_invoices
}: CreditCardsDtoTransformer): PaymentMethod[] {
  const cardMethods: PaymentMethod[] = (cards ?? []).map(item => {
    const paymentMethod: PaymentMethod = {
      paymentType: PaymentType.CREDIT_CARD,
      id: item.id,
      display: `**** ${item.last_4}`,
      cardType: getCardType(item.type),
      expiryDate: item.expiry
    };
    if (typeof item.is_mada === 'boolean') {
      paymentMethod.isMada = item.is_mada;
    }
    return paymentMethod;
  });

  const invoiceMethods = corporateInvoicesDtoToPaymentMethods(corporate_invoices);

  return [...cardMethods, ...invoiceMethods];
}

export const userWalletConfigDtoToModel = ({
  is_zero_wallet_balance,
  wallet_details: { amount: smallerUnits, currency, fraction_digits }
}: UserWalletConfigDto): UserWalletConfigModel => {
  const amount = !isNaN(smallerUnits) ? smallerUnits / Math.pow(10, fraction_digits) : smallerUnits;
  return {
    isZeroWalletBalance: is_zero_wallet_balance,
    userBalance: {
      amount,
      currency,
      fractionDigits: fraction_digits
    }
  };
};
